import { flexRender, Row, RowData, Table } from '@tanstack/react-table';

type TableBodyProps<TData extends RowData> = {
  table: Table<TData>;
  currentId?: string;
  onClick: (row: Row<TData>) => void;
};

export function TableBody<TData extends RowData>({ table, currentId, onClick }: TableBodyProps<TData>) {
  return (
    <tbody>
      {table.getRowModel().rows.map((row, index, array) => (
        <tr key={row.id} onClick={() => onClick(row)}>
          {row.getVisibleCells().map((cell) => (
            <td
              key={cell.id}
              style={{
                width: cell.column.getSize(),
                minWidth: cell.column.getSize(),
                borderWidth: '1px',
                borderBottomColor: 'var(--joy-palette-neutral-100)',
                backgroundColor: 'var(--joy-palette-neutral-50)',
                ...(currentId === row.id && {
                  backgroundColor: 'var(--joy-palette-common-white)',
                  borderBottomColor: 'var(--joy-palette-primary-500)',
                  borderWidth: '2px',
                }),
                ...(index === array.length - 1 && { borderBottom: 'none' }),
              }}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
